export default __webpack_public_path__ + "static/media/letter-2.530aa3f4.png";